export default __webpack_public_path__ + "static/media/arrowD.47fdd45c.png";